import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Switch } from "@/components/ui/switch";
import { Plus, Trash2 } from "lucide-react";
import { toast } from "sonner";

export default function AdminPromos() {
    const [items, setItems] = useState([]);
    const [code, setCode] = useState("");
    const [percent, setPercent] = useState("10");

    const load = async () => { const { data } = await api.get("/promos"); setItems(data); };
    useEffect(() => { load(); }, []);

    const add = async () => {
        if (!code.trim()) return;
        try {
            await api.post("/promos", { code: code.trim(), percent: parseFloat(percent) || 0, is_active: true });
            setCode(""); setPercent("10");
            toast.success("Promo added");
            load();
        } catch (e) { toast.error(e?.response?.data?.detail || "Failed"); }
    };
    const toggle = async (p) => {
        try { await api.put(`/promos/${p.id}`, { code: p.code, percent: p.percent, is_active: !p.is_active }); load(); }
        catch { toast.error("Failed"); }
    };
    const remove = async (p) => {
        if (!window.confirm(`Delete promo "${p.code}"?`)) return;
        await api.delete(`/promos/${p.id}`); load();
    };

    return (
        <section data-testid="admin-promos-page" className="max-w-2xl">
            <h2 className="font-serif text-3xl mb-6">Promo codes</h2>
            <div className="bg-card border border-border/60 rounded-2xl p-5 mb-6">
                <div className="grid grid-cols-1 sm:grid-cols-[1fr_120px_auto] gap-3 items-end">
                    <div><Label className="text-xs uppercase tracking-[0.2em]">Code</Label>
                        <Input data-testid="new-promo-code" value={code} onChange={(e) => setCode(e.target.value.toUpperCase())} placeholder="WELCOME10" className="mt-1 rounded-xl" /></div>
                    <div><Label className="text-xs uppercase tracking-[0.2em]">Percent</Label>
                        <Input data-testid="new-promo-percent" type="number" value={percent} onChange={(e) => setPercent(e.target.value)} className="mt-1 rounded-xl" /></div>
                    <Button data-testid="add-promo-btn" onClick={add} className="rounded-full bg-primary hover:bg-primary-hover h-10"><Plus className="h-4 w-4 mr-1" /> Add</Button>
                </div>
            </div>
            <ul className="space-y-2">
                {items.map((p) => (
                    <li key={p.id} data-testid={`promo-row-${p.id}`} className="flex items-center justify-between bg-card border border-border/60 rounded-2xl px-5 py-3">
                        <div>
                            <p className="font-serif text-lg">{p.code}</p>
                            <p className="text-xs text-muted-foreground">{p.percent}% off · {p.is_active ? "active" : "inactive"}</p>
                        </div>
                        <div className="flex items-center gap-2">
                            <Switch checked={p.is_active} onCheckedChange={() => toggle(p)} data-testid={`toggle-promo-${p.id}`} />
                            <Button variant="ghost" size="sm" onClick={() => remove(p)} data-testid={`delete-promo-${p.id}`} className="rounded-full text-destructive hover:text-destructive hover:bg-destructive/10"><Trash2 className="h-4 w-4" /></Button>
                        </div>
                    </li>
                ))}
            </ul>
        </section>
    );
}
